import React, { useRef, useEffect } from 'react';
import './AutoResizingTextArea.scss';

export type AutoResizingTextareaProps = {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void; // Added onKeyDown prop
};

export default function AutoResizingTextarea({
  value,
  onChange,
  placeholder,
  onKeyDown,
  disabled
}: {
  value: string;
  placeholder: string;
  onChange: (value: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLTextAreaElement>) => void;
  disabled?: boolean;
}) {
  const textareaRef = useRef(null);

  // This effect adjusts the textarea height after each render
  useEffect(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto'; // Reset height to recalc scrollHeight
      textarea.style.height = textarea.scrollHeight + 'px';
    }
  }, [value]);

  return (
    <textarea
      disabled={disabled}
      ref={textareaRef}
      value={value}
      onKeyDown={onKeyDown}
      onChange={(e) => {
        const newValue = e.target.value;
        onChange(newValue);
      }}
      placeholder={placeholder}
      className="auto-resize-textarea"
    />
  );
}
